import { selectProjectWellVspByIdTableData, useAppSelector } from '@core/core/store'
import { assertToBeDefine } from '@core/core/utils'
import type { FC } from 'react'

import { extractWellIdsContext, useStepController, WellsTable } from '../../components'
import type { OnChangeVspOffsetFunc } from '../../types'

type StepApplyVspProps = {
  onChangeVspOffset: OnChangeVspOffsetFunc
}
export const StepApplyVsp: FC<StepApplyVspProps> = ({ onChangeVspOffset }) => {
  const { activeStep } = useStepController()
  const wellIds = extractWellIdsContext(activeStep)

  assertToBeDefine(wellIds)

  const wellVsp = useAppSelector(state => selectProjectWellVspByIdTableData(state, wellIds))

  return <WellsTable hasNextStep={false} wellVsp={wellVsp} onChangeVspOffset={onChangeVspOffset} />
}
